import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { jabraTheme } from '../contexts/FormTheme/formThemes';

enum FormTheme {
  Light = 'light',
}

export type sitecoreFormTheme = {
  backgroundColor: Field<string>;
  primaryTextColor: Field<string>;
  secondaryTextColor: Field<string>;
};

export const getFormTheme = (theme = '', sitecoreFormTheme?: sitecoreFormTheme) => {
  let baseTheme;

  switch (theme.toLowerCase()) {
    case FormTheme.Light:
      baseTheme = jabraTheme.light;
      break;
    default:
      baseTheme = jabraTheme.default;
  }
  const sanitizeCssValue = (value: string): string => value.replace(/[^a-zA-Z0-9#\-_.]/g, '');
  const sitecoreBackgroundColor = sanitizeCssValue(sitecoreFormTheme?.backgroundColor?.value || '');
  const sitecorePrimaryTextColor = sanitizeCssValue(
    sitecoreFormTheme?.primaryTextColor?.value || ''
  );
  const sitecoreSecondaryTextColor = sanitizeCssValue(
    sitecoreFormTheme?.secondaryTextColor?.value || ''
  );

  return {
    backgroundColor: sitecoreBackgroundColor
      ? `bg-${sitecoreBackgroundColor}`
      : baseTheme.backgroundColor,
    primaryTextColor: sitecorePrimaryTextColor
      ? `text-${sitecorePrimaryTextColor}`
      : baseTheme.primaryTextColor,
    secondaryTextColor: sitecoreSecondaryTextColor
      ? `text-${sitecoreSecondaryTextColor}`
      : baseTheme.secondaryTextColor,
  };
};
